import { makeStyles } from '@material-ui/styles';

export const useStyles = (maxWidth, widthJoinAisle) =>
    makeStyles(() => ({
        aisle: {
            display: 'flex',
            height: '64px',
            flex: `0 1 ${widthJoinAisle || 64}px`,
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',

            fontWeight: 'bold',
            fontSize: '2em',

            [`@media all and (max-width: ${maxWidth}px)`]: {
                height: '56px',
                flex: `0 1 ${widthJoinAisle || 56}px`,

                fontSize: '1.3em',
            },
        },
    }));
